import { TenantIds } from '../enums/tenants.enum';

export interface TenantConfig {
  id: TenantIds;
  urls: string[];
}

export const TENANT_CONFIGS: TenantConfig[] = [
  {
    id: TenantIds.RADFORD,
    urls: [
        'radfordmoneyball.com',
        'dev.radfordmoneyball.com'
    ]
  },
  {
    id: TenantIds.MUSTANG,
    urls: [
      'dev.mustangmoneyball.com',
      'mustangmoneyball.com'
    ]
  }
]; 